import { Alert } from '@heroui/react';
import React, { useEffect } from 'react';
import { FieldErrors } from 'react-hook-form';

export interface FormErrorGroupProps {
  errors: FieldErrors;
}

export const FormErrorGroup: React.FC<FormErrorGroupProps> = ({ errors }) => {
  const extractMessages = (obj: FieldErrors, seen = new Set()): string[] => {
    let messages: string[] = [];
    if (!obj || seen.has(obj)) return messages;
    seen.add(obj);
    Object.entries(obj).forEach(([_, value]) => {
      if (value && typeof value === 'object') {
        if ('message' in value && typeof value.message === 'string') {
          const sanitizedMessage = value.message.replace(/\{\d+\}/g, '').trim();
          messages.push(sanitizedMessage);
        }
        messages = messages.concat(extractMessages(value as FieldErrors, seen));
      }
    });
    return messages;
  };

  const errorMessages = extractMessages(errors);

  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setIsVisible(true);
    }
  }, [errors]);

  return errorMessages.length > 0 ? (
    <div className="mb-2">
      <Alert
        color="danger"
        variant="faded"
        radius="sm"
        isVisible={isVisible}
        onClose={() => setIsVisible(false)}
      >
        <ul>
          {errorMessages.map((msg, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>{msg}</li>
          ))}
        </ul>
      </Alert>
    </div>
  ) : null;
};
